import HomeAdmin from '../components/Home/HomeAdmin';
import HomeSuperLider from '../components/Home/HomeSuperLider';

import { useAdminAuth } from '../context/AdminAuthContext';

function Home() {
    const { admin, loading } = useAdminAuth();

    if (loading) {
        return (
            <div className="content-inner container-fluid pb-0">
                <p>Cargando...</p>
            </div>
        );
    }

    const rolId = Number(admin?.rid);

    if (rolId === 1) {
        return <HomeAdmin />;
    }

    if (rolId === 5) {
        return <HomeSuperLider />;
    }

    return <>No cuentas con permisos</>;
}

export default Home;